import { queryOptions, useQuery } from '@tanstack/react-query'
// import * as Bluebird from 'bluebird'
import { omit } from 'lodash-es'

import { apiClient } from '@/apiClient.ts'

type UseFetchThumbnailArgs = {
  fileId: string
  pageNum?: number
  res?: 'high' | 'low'
}

export const generateOptions = (args: UseFetchThumbnailArgs) =>
  queryOptions({
    queryKey: ['thumbnail', args.fileId, omit(args, 'file')],
    queryFn: async () => {
      ///await Bluebird.delay(5000)

      return apiClient.files[':fileId'].thumbnail[':pageNum']
        .$get({
          param: {
            fileId: args.fileId,
            pageNum: args.pageNum ? String(args.pageNum) : undefined,
          },
          query: { res: args.res ?? 'low' },
        })
        .then(async (r) => await r.json())
    },
    staleTime: 60 * 10 * 1000,
  })

export const useFetchThumbnail = (
  args: UseFetchThumbnailArgs,
  options?: Partial<ReturnType<typeof generateOptions>>
) =>
  useQuery({
    ...generateOptions(args),
    ...options,
  })

useFetchThumbnail.queryOptions = generateOptions
